/* BK_QUICK_PILLS_v1 — quick add-to-cart from product card pills */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Desktop: translate vertical wheel into horizontal scroll on the pill strip
     so users can spin the wheel to scroll through sizes without holding Shift. */
  document.addEventListener('wheel', function (e) {
    var strip = e.target.closest && e.target.closest('.bk-pills');
    if (!strip) return;
    if (e.deltaY === 0) return;
    if (strip.scrollWidth <= strip.clientWidth) return; // no overflow → no need
    e.preventDefault();
    strip.scrollLeft += e.deltaY;
  }, { passive: false });

  /* Reveal scroll arrows + hide them at boundaries */
  function refreshArrows(strip) {
    var overflowing = strip.scrollWidth > strip.clientWidth + 1;
    strip.classList.toggle('bk-pills--overflowing', overflowing);
    var parent = strip.parentElement;
    if (!parent) return;
    var prev = parent.querySelector('[data-bk-pills-prev]');
    var next = parent.querySelector('[data-bk-pills-next]');
    if (prev) {
      if (overflowing) prev.removeAttribute('hidden');
      else prev.setAttribute('hidden', '');
      if (strip.scrollLeft <= 1) prev.setAttribute('data-at-start', '');
      else prev.removeAttribute('data-at-start');
    }
    if (next) {
      if (overflowing) next.removeAttribute('hidden');
      else next.setAttribute('hidden', '');
      var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;
      if (atEnd) next.setAttribute('data-at-end', '');
      else next.removeAttribute('data-at-end');
    }
  }
  function refreshAllStrips() {
    var strips = document.querySelectorAll('.bk-pills');
    for (var i = 0; i < strips.length; i++) {
      refreshArrows(strips[i]);
      if (!strips[i].__bkScrollBound) {
        strips[i].__bkScrollBound = true;
        strips[i].addEventListener('scroll', (function (s) { return function () { refreshArrows(s); }; })(strips[i]), { passive: true });
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllStrips);
  } else {
    refreshAllStrips();
  }
  window.addEventListener('resize', refreshAllStrips);

  /* Arrow click → smooth scroll the strip ~80% of its width */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest && e.target.closest('[data-bk-pills-prev]');
    var next = e.target.closest && e.target.closest('[data-bk-pills-next]');
    if (!prev && !next) return;
    e.preventDefault();
    e.stopPropagation();
    var arrow = prev || next;
    var strip = arrow.parentElement && arrow.parentElement.querySelector('.bk-pills');
    if (!strip) return;
    var dir = prev ? -1 : 1;
    strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: 'smooth' });
  });

  function refreshCartUI() {
    fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        // Update cart icon bubble (count badge)
        if (sections['cart-icon-bubble']) {
          var bubble = document.querySelector('cart-icon-bubble');
          if (bubble) {
            var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newInner = parsed.querySelector('cart-icon-bubble');
            if (newInner) bubble.innerHTML = newInner.innerHTML;
          }
        }
        // Update cart drawer + open it
        if (sections['cart-drawer']) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var newDrawer = parsed.querySelector('cart-drawer');
            if (newDrawer) {
              var newInner = newDrawer.querySelector('.drawer__inner');
              var oldInner = drawer.querySelector('.drawer__inner');
              if (newInner && oldInner) oldInner.replaceWith(newInner);
            }
            if (typeof drawer.open === 'function') drawer.open();
          }
        }
        // Dispatch generic event for any custom cart UIs
        document.dispatchEvent(new CustomEvent('bk:cart:added'));
      })
      .catch(function (err) { /* silent */ });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-bk-pill-add]');
    if (!pill) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Sold-out pill clicked: shake + bail
    if (pill.getAttribute('data-available') === 'false' || pill.disabled) {
      pill.classList.remove('bk-pill--shake');
      void pill.offsetWidth; /* force reflow so animation restarts */
      pill.classList.add('bk-pill--shake');
      setTimeout(function () { pill.classList.remove('bk-pill--shake'); }, 450);
      return;
    }

    // Already loading (rapid double-click): pulse to indicate "wait"
    if (pill.classList.contains('bk-pill--loading')) {
      pill.classList.remove('bk-pill--pulse');
      void pill.offsetWidth;
      pill.classList.add('bk-pill--pulse');
      setTimeout(function () { pill.classList.remove('bk-pill--pulse'); }, 350);
      return;
    }

    var variantId = pill.getAttribute('data-bk-pill-add');
    if (!variantId) {
      console.warn('[bk-pills] no variant id on pill', pill);
      return;
    }

    pill.classList.add('bk-pill--loading');

    // Timeout guard: 8s without response → mark as error
    var timedOut = false;
    var timeoutId = setTimeout(function () {
      timedOut = true;
      pill.classList.remove('bk-pill--loading');
      pill.classList.add('bk-pill--error');
      console.error('[bk-pills] cart add timed out (>8s)');
      setTimeout(function () { pill.classList.remove('bk-pill--error'); }, 1800);
    }, 8000);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (resp) {
        if (timedOut) return; /* already showed error */
        clearTimeout(timeoutId);
        pill.classList.remove('bk-pill--loading');
        if (!resp.ok || resp.data.status >= 400 || resp.data.errors) {
          console.error('[bk-pills] cart add failed', resp);
          pill.classList.add('bk-pill--error');
          setTimeout(function () { pill.classList.remove('bk-pill--error'); }, 1800);
          return;
        }
        pill.classList.add('bk-pill--added');
        refreshCartUI();
        setTimeout(function () { pill.classList.remove('bk-pill--added'); }, 1800);
      })
      .catch(function (err) {
        if (timedOut) return;
        clearTimeout(timeoutId);
        console.error('[bk-pills] cart add error', err);
        pill.classList.remove('bk-pill--loading');
        pill.classList.add('bk-pill--error');
        setTimeout(function () { pill.classList.remove('bk-pill--error'); }, 1800);
      });
  }, true /* capture phase — fire before Bull Kicks card-wide click handler */);
})();
